var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-power") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-690.000000, -296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schematic-View",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-+-Component",
    transform: "translate(39.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(4.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90566038,37 L47.0943396,37 L47.0943396,12 L4.90566038,12 L4.90566038,37 Z M49.0566038,42 L2.94339623,42 C1.10112785,42 0,40.8776651 0,39 L0,10 C0,8.12233494 1.10112785,7 2.94339623,7 L49.0566038,7 C50.8988722,7 52,8.12233494 52,10 L52,39 C52,40.8776651 50.8988722,42 49.0566038,42 L49.0566038,42 Z",
    id: "Fill-4",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0 C15.0164014,0 16,0.983598602 16,2.5 L16,2.5 C16,4.0164014 15.0164014,5 13.5,5 L8.5,5 C6.9835986,5 6,4.0164014 6,2.5 L6,2.5 C6,0.983598602 6.9835986,0 8.5,0 L13.5,0 Z",
    id: "Rectangle-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,0 C45.0164014,0 46,0.983598602 46,2.5 L46,2.5 C46,4.0164014 45.0164014,5 43.5,5 L38.5,5 C36.9835986,5 36,4.0164014 36,2.5 L36,2.5 C36,0.983598602 36.9835986,0 38.5,0 L43.5,0 Z",
    id: "Rectangle-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0357,25.3818 L13.0607,25.3818 C12.2327,25.3818 11.5607,24.7108 11.5607,23.8818 C11.5607,23.0528 12.2327,22.3818 13.0607,22.3818 L19.0357,22.3818 C19.8637,22.3818 20.5357,23.0528 20.5357,23.8818 C20.5357,24.7108 19.8637,25.3818 19.0357,25.3818",
    id: "Fill-7",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.27,22.3818 C40.1798408,22.3818 40.77,22.9719592 40.77,23.8818 L40.77,23.8818 C40.77,24.7916408 40.1798408,25.3818 39.27,25.3818 L33.295,25.3818 C32.3851592,25.3818 31.795,24.7916408 31.795,23.8818 L31.795,23.8818 C31.795,22.9719592 32.3851592,22.3818 33.295,22.3818 L39.27,22.3818 Z",
    id: "Fill-9",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0484,28.3691 C15.2204,28.3691 14.5484,27.6971 14.5484,26.8691 L14.5484,20.8941 C14.5484,20.0661 15.2204,19.3941 16.0484,19.3941 C16.8764,19.3941 17.5484,20.0661 17.5484,20.8941 L17.5484,26.8691 C17.5484,27.6971 16.8764,28.3691 16.0484,28.3691",
    id: "Fill-10",
    fill: "#FEFEFE"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwr);
export default __webpack_public_path__ + "static/media/PWR.2d497d595b94609d0406aea1cd411b0b.svg";
export { ForwardRef as ReactComponent };